<template>
  <div class="bg-gray-50 w-full px-2 py-4">
  <div
    class="flex flex-row items-center justify-between max-w-5xl mx-auto"
  >
    <!-- Text Section -->
    <div class="flex-1">
      <p class="font-extrabold text-gray-400 text-2xl sm:text-3xl leading-tight mb-1 sm:mb-0">
        <span class="block sm:inline">Smart.</span>
        <span class="block sm:inline"> Safe.</span>
        <span class="block sm:inline"> Seamless.</span>
      </p>
      <p class="text-gray-400 text-base sm:text-sm">
        Cutting-edge security for every payment you make.
      </p>
    </div>
    <!-- Image Section -->
    <img
      src="/v2/icons/order_summary_footer.png"
      alt="Payment Illustration"
      title="Payment Illustration"
      class="w-24 h-24 sm:w-32 sm:h-20 ml-auto object-contain mb-4 sm:mb-0"
    />
  </div>
</div>
  <div class="px-4 mt-4 mb-10" v-if="isMobile">
    <button
        class="w-full bg-primary hover:bg-primary-dark transition text-white text-sm font-semibold py-3 rounded shadow"
        @click="navigateToHomepage"
    >
        GO TO HOMEPAGE
    </button>
    </div>
</template>

<script setup>
const { isMobile, isDesktop } = useDevice();
const navigateToHomepage = () => {
    navigateTo({ path: "/" })
};
</script>
